/**
 * Theme JavaScript Entry Point
 * This file is processed by WP Scripts (webpack)
 */



// Critical JavaScript modules (above the fold)
import Navigation from './modules/navigation';
import StickyHeader from './modules/sticky-header';
import MobileNavigation from './modules/mobile-navigation';
import { devLog } from './modules/utils.js';

// Initialize critical modules immediately
document.addEventListener('DOMContentLoaded', () => {
    // Initialize critical modules - only on frontend
    if (!document.body.classList.contains('wp-admin') && !document.body.classList.contains('block-editor-page')) {
        new Navigation();
        new StickyHeader();
        
        // Initialize mobile navigation immediately
        const mobileNavInstance = new MobileNavigation();
        
        // Make MobileNavigation available globally for debugging
        window.MobileNavigation = MobileNavigation;
        window.mobileNavInstance = mobileNavInstance;
        
        // Initialize DIPG mobile navigation immediately if on DIPG theme
        if (document.body.classList.contains('dipg-theme')) {
            import('./modules/dipg-mobile-navigation').then(async module => {
                const DIPGMobileNavigationClass = await module.default();
                new DIPGMobileNavigationClass();
            }).catch(error => {
                console.error('Error loading DIPG mobile navigation:', error);
            });
        }
    }
});

// Lazy load non-critical modules after page load
window.addEventListener('load', () => {
    if (!document.body.classList.contains('wp-admin') && !document.body.classList.contains('block-editor-page')) {
        // Mobile navigation is now loaded immediately
        

        
        // Load search enhancement only when search is present
        if (document.querySelector('.search-form, .facetwp-facet')) {
            import('./modules/search-enhancement').then(module => {
                // Search enhancement module loaded
            });
        }
        
        // Load events accordion only when events are present
        if (document.querySelector('.events-accordion, .event-item, [data-event-toggle]')) {
            import('./modules/events-accordion').then(module => {
                // Events accordion module is self-initializing
                devLog('Events accordion module loaded');
            });
        }
        
        // Load accordion module when accordion blocks are present
        if (document.querySelector('.accordion, [data-accordion-toggle]')) {
            import('./modules/accordion').then(module => {
                // Accordion module is self-initializing
                devLog('Accordion module loaded');
            });
        }
        
        // Load kids search and infinite scroll modules when kids blocks are present
        if (document.querySelector('.kids-block--archive')) {
            import('./modules/kids-search').then(module => {
                devLog('Kids search module loaded');
            });
            
            import('./modules/kids-infinite-scroll').then(module => {
                devLog('Kids infinite scroll module loaded');
            });
        }
        
        // Load randomized kids module when randomized kids blocks are present
        if (document.querySelector('.kids-block[data-randomize="true"]')) {
            import('./modules/randomized-kids').then(module => {
                devLog('Randomized kids module loaded');
            });
        }
        
        // Load modal system when needed
        if (document.querySelector('.kid-donate-button') || 
            document.querySelector('.video-modal-trigger') || 
            typeof window.kidModalData !== 'undefined') {
            import('./modules/modal-manager').then(module => {
                devLog('Modal system loaded');
            });
        }
        
        // Load DIPG donate module on pages with donate buttons or donate page
        if (document.querySelector('.dipg-amount-btn') || 
            document.querySelector('.dipg-donate-btn') || 
            window.location.pathname.includes('/donate')) {
            import('./modules/dipg-donate').then(module => {
                devLog('DIPG donate module loaded');
            });
        }
    }
});

// Load FacetWP pagination scroll module when FacetWP is present
if (typeof FWP !== 'undefined' || document.querySelector('.facetwp-template')) {
    import('./modules/facetwp-pagination-scroll').then(module => {
        devLog('FacetWP pagination scroll module loaded');
    });
}

// Export for use in other files if needed
export default {
    init: () => {
        // Theme initialized
    }
};
